import {
  ComponentFactoryResolver,
  ComponentRef,
  ViewContainerRef
} from '@angular/core';

export class Tab {
  title: string;
  model: any;
  componentClass: any;
  //This can be moved to a different component if you want to make a stack of components inside a tab (cfr. Corporify)
  component?: ComponentRef<any>;
  inputs: any;
  outputs: any;
  viewContainer: ViewContainerRef;
  url: string;
  project: any;

  constructor(
    title: string,
    url: string,
    componentClass: any,
    model: any,
    project: any,
    inputs: any,
    outputs?: any
  ) {
    this.title = title;
    this.url = url;
    this.componentClass = componentClass;
    this.model = model;
    this.project = project;
    this.inputs = inputs;
    this.outputs = outputs;
  }

  private createComponent(
    componentClass: any,
    inputs: any,
    outputs: any,
    componentFactoryResolver: ComponentFactoryResolver,
    view: ViewContainerRef
  ): ComponentRef<any> {
    // Create an instance of this component
    const factory = componentFactoryResolver.resolveComponentFactory(
      componentClass
    );
    const newComponent = factory.create(view.parentInjector);
    if (inputs) {
      Object.keys(inputs).map(key => {
        newComponent.instance[key] = inputs[key];
      });
    }
    if (outputs) {
      Object.keys(outputs).map(key => {
        newComponent.instance[key] = outputs[key];
      });
    }
    if (this.model) {
      newComponent.instance['model'] = this.model;
    }
    if (this.project) {
      newComponent.instance['project'] = this.project;
    }
    return newComponent;
  }

  createComponentView(
    componentFactoryResolver: ComponentFactoryResolver,
    target?: ViewContainerRef
  ) {
    if (target) {
      this.viewContainer = target;
    }
    this.component = this.createComponent(
      this.componentClass,
      this.inputs,
      this.outputs,
      componentFactoryResolver,
      this.viewContainer
    );
  }

  closeTab() {
    if (this.component) {
      this.component.destroy();
    }
  }
}
